import {throttle} from './utils/throttle';
import {headerMargin, headerOnScroll} from './components/header';

document.addEventListener('DOMContentLoaded', () => {
  throttle('resize', 'optimizedResize');
  throttle('scroll', 'optimizedScroll');

  headerMargin();
  headerOnScroll();
});
